<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
      :customSub="true"
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {getDepartmentAllList} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [], // 适用部门
        form: [
          {
            label: '围栏名称',
            value: 'fenceName',
            type: 'input',
            placeholder: '请输入围栏名称',
          },
          {
            label: '适用部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择适用部门',
          },
          // {
          //   label: '有效时间',
          //   value: 'time',
          //   type: 'date',
          //   placeholder: '请选择有效时间',
          //   attr: {
          //     type: 'daterange',
          //   },
          // },
          {
            label: '围栏类型',
            value: 'fenceType',
            type: 'checkbox',
            options: [
              {label: '普通围栏', value: 1},
              {label: '线路', value: 2},
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // if (searchBoxData.time && searchBoxData.time.length > 0) {
      //   searchBoxData.effectiveStartTime = this.formatDate(searchBoxData.time[0]);
      //   searchBoxData.effectiveEndTime = this.formatDate(searchBoxData.time[1]);
      //   delete searchBoxData.time;
      // }
      if (searchBoxData.fenceType) {
        searchBoxData.fenceType = searchBoxData.fenceType.length < 2 ? searchBoxData.fenceType[0] : '';
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
